var _dec, _dec2, _dec3, _dec4, _class, _class2, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { "BeanInfo" as __z_BeanInfo } from "zova";
import { BeanBase, cast, deepEqual, disposeInstance, Use } from 'zova';
import { Service } from 'zova-module-a-bean';
const SymbolSliceOptionsOriginal = Symbol('SymbolSliceOptionsOriginal');
export let ServiceComposer = (_dec = Service(), _dec2 = __z_BeanInfo({
  module: "a-behavior"
}), _dec3 = Use("a-bean.sys.onion"), _dec4 = Reflect.metadata("design:type", typeof SysOnion === "undefined" ? Object : SysOnion), _dec(_class = _dec2(_class = (_class2 = class ServiceComposer extends BeanBase {
  constructor(...args) {
    super(...args);
    this._composer = void 0;
    this._onionSlicesOriginal = void 0;
    _initializerDefineProperty(this, "$$sysOnion", _descriptor, this);
  }
  async __init__(behaviors) {
    await this.load(behaviors);
  }
  __dispose__() {
    if (this._onionSlicesOriginal) {
      for (const onionSlice of this._onionSlicesOriginal) {
        disposeInstance(onionSlice.beanInstance);
      }
    }
  }
  async load(behaviors) {
    await this.$renderFreezeScope(async () => {
      await this._loadInner(behaviors);
    });
  }
  async _loadInner(behaviors) {
    // onionItems
    const onionItems = this._prepareOnionItems(behaviors);
    // load onions
    const onionSlices = await this.$$sysOnion.behavior.loadOnions(onionItems);
    // create behaviors
    for (const onionSlice of onionSlices) {
      const onionSliceOriginal = this._onionSlicesOriginal?.find(item => item.beanFullName === onionSlice.beanFullName);
      if (onionSliceOriginal) {
        onionSlice.beanInstance = onionSliceOriginal.beanInstance;
        if (!deepEqual(onionSliceOriginal[SymbolSliceOptionsOriginal], onionSlice.options)) {
          await cast(onionSlice.beanInstance).onOptionsChange(onionSlice.options);
        }
      } else {
        onionSlice.beanInstance = await this.bean._newBean(onionSlice.beanFullName, true, onionSlice.options);
      }
      onionSlice[SymbolSliceOptionsOriginal] = onionSlice.options;
    }
    // dispose original behaviors
    if (this._onionSlicesOriginal) {
      for (const onionSlice of this._onionSlicesOriginal) {
        const exists = onionSlices.find(item => item.beanFullName === onionSlice.beanFullName);
        if (!exists) {
          disposeInstance(onionSlice.beanInstance);
        }
      }
    }
    // save
    this._onionSlicesOriginal = onionSlices;
    // compose
    this._composer = this.$$sysOnion.behavior.compose(onionSlices, (onionSlice, props, next) => {
      const beanInstance = cast(onionSlice.beanInstance);
      return cast(beanInstance).render(props, next);
    });
  }
  render(props, next) {
    return this._composer(props, next);
  }
  _prepareOnionItems(behaviors) {
    const onionItems = [];
    return this._prepareOnionItemsInner(onionItems, behaviors);
  }
  _prepareOnionItemsInner(onionItems, behaviors) {
    const behaviors2 = Array.isArray(behaviors) ? behaviors : [behaviors];
    for (const behaviorItem of behaviors2) {
      if (typeof behaviorItem === 'string') {
        onionItems.push({
          name: behaviorItem,
          options: undefined
        });
      } else if (Array.isArray(behaviorItem)) {
        this._prepareOnionItemsInner(onionItems, behaviorItem);
      } else if (typeof behaviorItem === 'object') {
        for (const key in behaviorItem) {
          let options = behaviorItem[key];
          if (options === false) continue;
          if (options === true) options = undefined;
          onionItems.push({
            name: key,
            options
          });
        }
      }
    }
    return onionItems;
  }
}, _descriptor = _applyDecoratedDescriptor(_class2.prototype, "$$sysOnion", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2)) || _class) || _class);